import { EditProps } from "react-admin";
import { DefaultEdit } from "../../../components";
import { RoleForm } from "./RoleForm";

const RoleEdit= (props:EditProps) => {
  return (
    <DefaultEdit {...props} mutationMode="pessimistic">
      <RoleForm isEdit={true} />
    </DefaultEdit>
  );
};

export { RoleEdit };
